import { createContext } from 'react';
import type { CalendarWithTimeWheelContextT } from './useConfigCalendarWithTimeWheelCTX.js';
export const defaultCalendarWithTimeWheelContext = {} as CalendarWithTimeWheelContextT;

/** Context for cross component communication */
export const CalendarWithTimeWheelContext = createContext<CalendarWithTimeWheelContextT>(
  defaultCalendarWithTimeWheelContext,
);

export default CalendarWithTimeWheelContext;
